'use client';

import { supporterDetailsQuery } from '../queries.ts';
import {
  getSupporterEmail,
  getSupporterFullName,
  getSupporterInitials,
  getSupporterPreferredName,
} from '../utils/name-format.ts';
import { useSupporterQuery } from './base.ts';

export enum NameFormats {
  preferred = 'preferred',
  full = 'full',
  initials = 'initials',
  email = 'email',
}

export const useSupporterDetails = () => {
  return useSupporterQuery(supporterDetailsQuery);
};

export const useSupporterName = (format: NameFormats): string | undefined => {
  const { data: details } = useSupporterDetails();

  switch (format) {
    case NameFormats.full: {
      return getSupporterFullName(details);
    }
    case NameFormats.initials: {
      return getSupporterInitials(details);
    }
    case NameFormats.email: {
      return getSupporterEmail(details);
    }
    case NameFormats.preferred:
    default: {
      return getSupporterPreferredName(details);
    }
  }
};
